import React, { ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GUTTOR_SPACE} from '../../../../../../shared/constants/commonConstants';
import { RootState } from '../../../../../../store';
import { NewAdmissionState } from '../../../../../../store/models/newAdmissionModel';
import { getIsPageNameNewAdmission } from '../../../service/crmUtils';

import { withRouter } from 'react-router-dom';
import { useSmoothScroll } from '../../../../../../shared/hooks/useSmoothScroll';
import { setBeneficiaryList, setBeneficiarySearchResponsePayerId, setShowBeneficiaryCard, setShowPayerNotConfiguredMessage } from '../../../../../../store/actions/newAdmissionAction';
import BlueBgInformativeAlert from '../../../../../../shared/components/Alert/BlueBgInformativeAlert';
import { Row } from 'antd';
import BeneficiarySearchPanelRedesign from '../BeneficiarySearchPanel/BeneficiarySearchPanelRedesign';
import RPABeneficiarySearchPanelRedesign from '../RPABeneficiarySearchPanel/RPABeneficiarySearchPanelRedesign';
import CONTROL_CONFIG_BASED_ON_PAYER from '../../../../../../config/formControlConfig';

const BeneficiarySearchRedesign = ({ form, location: { pathname },
  completeStep, resetStep, resetSteps, admissionForm }: any): ReactElement | null => {
  useSmoothScroll('NA-benef-search');
  const dispatch = useDispatch();
  const [text, setText] = useState<any>([]);
  const {beneficiarySearchResponsePayerId, beneficiarySearchResponsePayerName, showPayerNotConfiguredMessage }: any =
  useSelector((state: RootState): NewAdmissionState =>  state.newAdmission);

  const { isLoadingPreData } = useSelector((state: RootState): NewAdmissionState =>
    state.newAdmission);
  const { payerList: { payer: { isRpaPayer, isOnMailPayer, name }, allPayers } } = useSelector((state: RootState): RootState => state);
  const payerConfig = CONTROL_CONFIG_BASED_ON_PAYER[name];
  const payerConfigValues = Object.values(payerConfig || '');
  const isShowProductName = payerConfigValues?.some((config: any): any => Boolean(config?.showProductName));
  const commonBenefProps = {
    form,
    isLoading: isLoadingPreData,
    completeStep,
    resetStep,
    resetSteps,
    admissionForm,
  };

  useEffect((): any => {
    if (beneficiarySearchResponsePayerId > 0) {
      const finalPayer = allPayers.find((p: any): any => (p.id === beneficiarySearchResponsePayerId && p.isGovtScheme === false));
      if (!finalPayer) {
        dispatch(setBeneficiaryList([]));
        dispatch(setShowBeneficiaryCard(false));
        dispatch(setShowPayerNotConfiguredMessage(true));
        const disabledPayer = beneficiarySearchResponsePayerName ? beneficiarySearchResponsePayerName : beneficiarySearchResponsePayerId;
        setText(['Member belongs to ', <b key="text3">{disabledPayer}</b>,
        '. Hospital is ', <b key="text4">not in the network</b>, ' of ', `${disabledPayer}`]);
        dispatch(setBeneficiarySearchResponsePayerId(0));
      }
    }
  }, [beneficiarySearchResponsePayerId]);

  let isBenefSearchShow = true;

  if (!getIsPageNameNewAdmission(pathname)) {
    isBenefSearchShow = false;
  }
  if (!isBenefSearchShow) {
    return null;
  }
  return <>
  {!isOnMailPayer ?
    <div className="NA-benef-search"> {
      (isRpaPayer && !isShowProductName) ?
      <RPABeneficiarySearchPanelRedesign
        {...commonBenefProps}
      /> :
      <BeneficiarySearchPanelRedesign
        {...commonBenefProps}
      />
    }
    {
      showPayerNotConfiguredMessage &&
      <Row gutter={GUTTOR_SPACE} className="flex flex-element justify-center align-center">
        <BlueBgInformativeAlert okButtonRequired={false} text={text}/>
      </Row>
    }
    </div> : <></>
  }
  </>;
};

export default withRouter(BeneficiarySearchRedesign);
